import * as React from "react";
import Video, { VideoProps } from "~/components/video/video";

export interface IVideoViewProps {
    contextModel: VideoProps;
}

class VideoView extends React.PureComponent<IVideoViewProps> {
    public render() {
        return <Video {...this.props.contextModel} />;
    }
}

export default VideoView;
